import 'twin.macro';
import 'styled-components/macro';

import { Button } from 'play/atoms/button/Button';
import { Modal, ModalBody, ModalFooter } from 'play/molecules/modal/Modal';
import { shortEnglishHumanizer } from 'support/dates';

import { ReactComponent as IdleNightMask } from './idle_night_mask.svg';

export interface IdleModalProps {
  open: boolean;
  msRemaining: number;

  onClose?(): void;
  onExit?(): void;
}

export const IdleModal = ({ open, msRemaining, onClose, onExit }: IdleModalProps) => (
  <Modal title="Are you still there?" width="large" open={open} hideCloseIcon onClose={onClose}>
    <ModalBody tw="text-gray-15">
      <IdleNightMask tw="mx-auto mb-1" />

      <span tw="text-gray-70">Shutting down in: </span>
      {shortEnglishHumanizer(msRemaining, { round: true, delimiter: ', ' })}
    </ModalBody>

    <ModalFooter>
      <Button variant="outline" tw="mr-2" onClick={onExit}>
        Exit
      </Button>

      <Button onClick={onClose}>I'm still here</Button>
    </ModalFooter>
  </Modal>
);
